export default __webpack_public_path__ + "static/media/services.db9aaacc.svg";